import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_crm/crm")({
  beforeLoad: ({ context }) => guardRoute(context.me, "crm"),
  component: Outlet,
});
